import { type DeliveryChunk, type OrderDeliveryMethod, OrderDeliveryMethods } from '@/shared/api/order';
import { formatTimestampInterval, type FormatTimestampIntervalOptions, toUnixTimestamp } from '@/shared/lib/datetime';

export function getOrderDeliveryInterval(
    {
        method,
        deliveryChunks,
        chunkIndex,
    }: { method: OrderDeliveryMethod; deliveryChunks: Array<DeliveryChunk>; chunkIndex: number },
    options: FormatTimestampIntervalOptions = { showOnlyDate: false }
): string | null {
    let interval = null;

    if (!deliveryChunks[chunkIndex]) {
        return null;
    }

    if (method === OrderDeliveryMethods.COURIER) {
        interval = deliveryChunks[chunkIndex].delivery_info.courier_interval;
    }

    if (method === OrderDeliveryMethods.PICKUP_POINT) {
        interval = deliveryChunks[chunkIndex].delivery_info.pickup_point_interval;
    }

    if (method === OrderDeliveryMethods.SELF_PICK_UP) {
        interval = deliveryChunks[chunkIndex].delivery_info.self_pick_up_interval;
    }

    if (!interval) {
        return null;
    }

    const intervalFrom = toUnixTimestamp(interval.from);
    const intervalTo = toUnixTimestamp(interval.to);

    return intervalFrom && intervalTo
        ? formatTimestampInterval(
              {
                  from: intervalFrom,
                  to: intervalTo,
              },
              options
          )
        : null;
}
